import { Route, Routes } from 'react-router-dom';

import { CatalogPage } from './catalogs/pages/CatalogEdit/CatalogPage';
import { CatalogValuePage } from './catalogs/pages/CatalogValueEdit/CatalogValuePage';

export const ConfigurationRouting = () => {
  return (
    <>
      <Routes>
        <Route path="catalog/list" element={<CatalogPage />} />
        <Route path="catalog/:id/list" element={<CatalogValuePage />} />
      </Routes>
    </>
  );
};
